import { useCallback } from 'react';

type VibrationType = 'tap' | 'select' | 'longPress' | 'error' | 'success';

const vibrationPatterns: Record<VibrationType, number | number[]> = {
  tap: 30,
  select: 50,
  longPress: [100, 50, 100],
  error: [50, 100, 50, 100],
  success: [50, 30, 50]
};

export const useVibration = () => {
  const isSupported = 'vibrate' in navigator;

  const vibrate = useCallback((type: VibrationType) => {
    if (isSupported) {
      navigator.vibrate(vibrationPatterns[type]);
    }
  }, [isSupported]);

  return { vibrate, isSupported };
}; 